import { render } from "./TerminosDePrivacidad.vue?vue&type=template&id=70e08d1c&scoped=true"
const script = {}

import "./TerminosDePrivacidad.vue?vue&type=style&index=0&id=70e08d1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e08d1c"]])

export default __exports__